export default function Table(props) {
  const {t, expenses, onDelete, onUpdate, onAdd} = props;

  return (
      <table className="table-fixed w-full mb-8">
        <thead>
        <tr>
          <th className="w-1/2 py-2">{t("name")}</th>
          <th className="w-1/2 py-2">{t("sum")}</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        {expenses.map((expense, index) => (
            <tr key={index}>
              <td className="p-2">
                <input
                    type="text"
                    name="name"
                    value={expense.name}
                    onChange={(event) => onUpdate(index, event)}
                    className="w-full border-gray-500 rounded px-2 py-1"
                    placeholder={t("name")}
                />
              </td>
              <td className="p-2">
                <div className="flex items-center">
                  <span className="mr-2">{t("currency")}</span>
                  <input
                      type="number"
                      name="sum"
                      value={expense.sum}
                      onChange={(event) => onUpdate(index, event)}
                      className="w-full border-gray-500 rounded px-2 py-1"
                      placeholder="0.00"
                  />
                </div>
              </td>
              <td className="text-start py-0">
                {index === expenses.length - 1 ? (
                    <button className="add"
                            onClick={onAdd}>+</button>
                ) : (
                    <button className="delete"
                            onClick={() => onDelete(index)}>x</button>
                )}
              </td>
            </tr>
        ))}
        </tbody>
      </table>
  );
}